import { mockIndexItems } from '@/mocks/homeData';

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: { bg: 'bg-primary-100/80', text: 'text-primary-700', border: 'hover:border-primary-200' },
  accent: { bg: 'bg-accent-100/80', text: 'text-accent-700', border: 'hover:border-accent-200' },
  secondary: { bg: 'bg-secondary-100/80', text: 'text-secondary-700', border: 'hover:border-secondary-200' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            漫画分类索引
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            九大分类覆盖全类型漫画，一键直达你想看的精彩世界
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {mockIndexItems.map((item, idx) => {
            const c = colorMap[item.color];
            return (
              <a
                key={idx}
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className={`group flex items-center gap-4 p-4 md:p-5 bg-background-50 border border-background-200/70 rounded-xl ${c.border} transition-all duration-300 cursor-pointer`}
              >
                <div className={`w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-lg ${c.bg} ${c.text} text-lg`}>
                  <i className={item.icon}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.count}</p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}